// HashLink
// Scroll on click/Documentready

// Scroll margin from top
if (typeof scrollMargin == 'undefined') {
    var scrollMargin = 0;
}

// When not defined there's no fixed element
if (typeof fixedHeader == 'undefined') {
    var fixedHeader = false;
} else {
    var headerHeight = $('.header-section.fixed').height();
}


$(document).ready(function() {
    smoothScroll();
});

// On click
function smoothScroll() {
    $('body').on('click', 'a[data-scroll-link]', function(e) {
        e.preventDefault();

        // find scrollLink
        var scrollLink = $(this).attr('data-scroll-link');

        // if mobile menu is open, close it after click
        if($('body').hasClass('open-menu')) {
            $('#mobile-menu').empty();
            $('body.open-menu').removeClass('open-menu');
        }

        // if link is on the page scroll
        if($('#'+scrollLink).length>0) {
            if (fixedHeader != false) {
                $('html,body').animate({scrollTop:$('#'+scrollLink).offset().top-headerHeight-scrollMargin}, 500);
            } else {
                $('html,body').animate({scrollTop:$('#'+scrollLink).offset().top-scrollMargin}, 500);
            }
            // if link isn't on the page redirect to BASE_HREF
        } else {
            location.href = BASE_HREF+'#'+scrollLink;
            return false;
        }
    });
}


$(window).on('load', function() {

    // HashLink Scroll on Documentready
    if(window.location.hash) {

        // find hash
        var hash = window.location.hash.substring(1);

        // Check if id exists on page
        if($('#'+hash+'').length>0) {
            if(hash.substring(0, 4) == "tab-") {
                if (fixedHeader != false) {
                    $('html,body').animate({scrollTop:$('#'+hash).offset().top-headerHeight-scrollMargin}, 0);
                } else {
                    $('html,body').animate({scrollTop:$('#'+hash).offset().top-scrollMargin}, 0);
                }
            } else {
                if (fixedHeader != false) {
                    $('html,body').animate({scrollTop:$('#'+hash).offset().top-headerHeight-scrollMargin}, 0);
                } else {
                    $('html,body').animate({scrollTop:$('#'+hash).offset().top-scrollMargin}, 0);
                }
            }
        }
    }
});
